import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
import { ButtonAnchor } from '../ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
const pasos = [{
  title: 'Buscás el vehículo',
  text: 'Filtrá el catálogo por marca, modelo, año o presupuesto.'
}, {
  title: 'Consultás con un vendedor',
  text: 'Por WhatsApp o formulario, con respuesta en el día.'
}, {
  title: 'Coordinamos asesoramiento',
  text: 'Te mostramos la unidad y despejamos dudas técnicas.'
}, {
  title: 'Evaluamos financiación o permuta',
  text: 'Armamos la mejor combinación para tu presupuesto.'
}, {
  title: 'Avanzás con seguridad',
  text: 'Documentación, verificación y transferencia acompañadas.'
}];
export function Proceso() {
  return <Section id="proceso" className="bg-surface" data-id="element-345" data-mp="14ak12z8tpk4p">
      <SectionHeading title="Comprar con VCARS es simple" lead="Cinco pasos claros, sin vueltas y con un asesor acompañándote en cada uno." data-id="element-346" data-mp="147xxfap1zorr" />
      <ol className="grid gap-px overflow-hidden rounded-2xl border border-line bg-line md:grid-cols-5" data-id="element-347" data-mp="urr0bso1fmv3">
        {pasos.map((p, i) => <li key={p.title} className="flex flex-col bg-surface2/60 p-6" data-id="element-348" data-mp="qtbevt7lumjs" data-mpi={i}>
            <span className="text-[13px] font-black text-neon" data-id="element-349" data-mp="lyxgrj1k61bf">
              Paso {i + 1}
            </span>
            <h3 className="mt-3 text-[15px] font-bold leading-snug text-white" data-id="element-350" data-mp="h15epw778yti">
              {p.title}
            </h3>
            <p className="mt-2 text-[13.5px] leading-relaxed text-mist" data-id="element-351" data-mp="bzy840gsm5of">{p.text}</p>
          </li>)}
      </ol>
      <div className="mt-8" data-id="element-352" data-mp="31cpy6f8gso6">
        <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" data-id="element-353" data-mp="32nsy40utwe8">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-354" data-mp="3u9s337sapyqv" />
          Quiero comunicarme con un vendedor
        </ButtonAnchor>
      </div>
    </Section>;
}